module.exports = __webpack_public_path__ + "media/images/patent/y_2-ea7df36ce97eda9b4562bae6c3f166c8.jpg";